import { useEffect, useState } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import { FaBars } from 'react-icons/fa';
import { LiaTimesSolid } from 'react-icons/lia';

const Header = () => {
    const [opened, setOpened] = useState(true);
    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        let timeoutId = null;

        const handleScroll = () => {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
            timeoutId = setTimeout(() => {
                const scrolled = window.scrollY > 20;
                setIsScrolled(scrolled);
            }, 10);
        };

        // Check initial scroll position
        if (window.scrollY > 20) {
            setIsScrolled(true);
        }

        window.addEventListener('scroll', handleScroll, { passive: true });

        return () => {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <header className={`site-header ${isScrolled ? 'is-sticky' : ''}`}>
            <div className="container">
                <nav className="header-nav-container">
                    <div className="brand">
                        <a href="#home" aria-label="Fefine Home">
                            <img
                                src={require('../assets/brand/logo-white.png')}
                                alt="Fefine Logo"
                                className="brand-logo"
                            />
                        </a>
                    </div>

                    {/* Desktop Pill Navigation */}
                    <div className="nav-pill-wrapper d-none d-md-flex">
                        <a href="#home" className="nav-item-link active">Home</a>
                        <a href="#about-us" className="nav-item-link">About us</a>
                        <a href="#products" className="nav-item-link">Our products</a>
                        <a href="#contact-us" className="nav-item-link">Contact us</a>
                        <a
                            href="https://rzp.io/rzp/5DwrELl0"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn-buy-pill"
                        >
                            Buy now
                        </a>
                    </div>

                    {/* Mobile Navigation Toggle */}
                    <div className="d-flex d-md-none align-items-center">
                        <Dropdown show={!opened} onToggle={(isOpen) => setOpened(!isOpen)}>
                            <Dropdown.Toggle variant="light" className="mobile-toggle-btn" aria-label="Toggle navigation">
                                {opened ? <FaBars /> : <LiaTimesSolid />}
                            </Dropdown.Toggle>

                            <Dropdown.Menu className="mobile-nav-dropdown shadow-lg">
                                <Dropdown.Item href="#home" onClick={() => setOpened(true)}>Home</Dropdown.Item>
                                <Dropdown.Item href="#about-us" onClick={() => setOpened(true)}>About us</Dropdown.Item>
                                <Dropdown.Item href="#products" onClick={() => setOpened(true)}>Our products</Dropdown.Item>
                                <Dropdown.Item href="#contact-us" onClick={() => setOpened(true)}>Contact us</Dropdown.Item>
                                <Dropdown.Divider />
                                <div className="p-2">
                                    <a
                                        href="https://rzp.io/rzp/5DwrELl0"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="btn-buy-pill w-100 text-center d-block text-decoration-none"
                                    >
                                        Buy now
                                    </a>
                                </div>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </nav>
            </div>
        </header>
    );
};

export default Header;
